export default "__VITE_ASSET__Du_A1cpt__"